<mat-sidenav-container class="sidenav-container" layout="column" flex>
    <mat-sidenav
        #drawer
        mode="over"
        position="end"
        class="sidenav"
        [fixedInViewport]="true"
    >
        <div fxLayout="column" fxFlex>
            <div class="sidenav-header">
                <h1 class="sidenav-title">Navegar</h1>
                <dsn-button-rounded
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-xmark'"
                    [size]="'medium'"
                    (click)="toggleDrawer()"
                ></dsn-button-rounded>
            </div>
            <div class="horizontal-divider"></div>
            <div fxLayout="column" fxFlex>
                @defer (when !loading) {
                    <app-report-dashboard-sidenav-list
                        class="full-height"
                        [report]="report"
                        (onNavigate)="handleNavigation($event)"
                    ></app-report-dashboard-sidenav-list>
                }
            </div>
        </div>
    </mat-sidenav>

    <mat-sidenav-content fxFlex id="ReportPreviewScroll">
        <div style="width: 100%; height: 100%" fxLayout="column">
            <div id="Container" fxLayout="column">
                <div
                    class="report-balance_desktop-component-section"
                    style="z-index: 998"
                    [style.top]="previewMode ? '0' : '-159px'"
                    [style.position]="previewMode ? 'inherit' : 'sticky'"
                    fxLayout="column"
                >
                    <app-report-header
                        [options]="report?.options"
                        [reportName]="report?.props?.name"
                        [company]="company"
                    ></app-report-header>

                    <div
                        style="top: 0; z-index: 998"
                        [style.position]="previewMode ? 'inherit' : 'sticky'"
                        [style.background-color]="
                            'var(--background-color-primary)'
                        "
                    >
                        <app-report-toolbar
                            [report]="report"
                            [options]="report?.options"
                            [company]="company"
                            [loading]="loading"
                            [scenarios]="report?.scenarios"
                            [budgets]="report?.budgets"
                            [projections]="report?.projections"
                            [dropdowns]="{
                                period: true,
                                comparation: true
                            }"
                            [dropdownConfigs]="{
                                period: {
                                    equalYear: true
                                },
                                comparation: {
                                    equalYear: false
                                }
                            }"
                            [report]="report"
                            (handleChangePeriod)="onChangePeriod($event)"
                            (handleChangeComparation)="
                                onChangeComparation($event)
                            "
                            (handleResetPeriod)="handleResetPeriod.emit()"
                        ></app-report-toolbar>
                    </div>
                </div>
                <div
                    fxLayout="{{ chatNandaService.isOpen ? 'row' : 'column' }}"
                    [style]="
                        chatNandaService.isOpen
                            ? 'margin-right: 0px;position: relative;'
                            : ''
                    "
                >
                    <div
                        class="report-dashboard_desktop-component_section-column gap-16"
                        fxLayout="column"
                        fxFlex="{{
                            chatNandaService.isOpen && !previewMode
                                ? '65'
                                : '100'
                        }}"
                        [style.marginBottom]="'138px'"
                    >
                        <div
                            class="gap-24 margin-0-24"
                            style="gap: var(--spacing-24)"
                            fxLayout="column"
                        >
                            @if (
                                !company?.isGroup && preferenceService.viewBench
                            ) {
                                <dsn-expand-collapse
                                    id="SectionBenchmarking"
                                    [isExpanded]="
                                        sectionStates['SectionBenchmarking']
                                    "
                                    [customIcon]="
                                        'images/icons/benchmarking-icon.svg'
                                    "
                                    [label]="'Benchmarking'"
                                    [type]="'default'"
                                    [style.display]="
                                        hasBenchmarking ? 'block' : 'none'
                                    "
                                    [fontSize]="'medium'"
                                >
                                    <app-report-beachmarking-section
                                        [report]="report"
                                        [company]="company"
                                        [loading]="loading"
                                        [previewMode]="previewMode"
                                        (handleBenchmarkingDataLoaded)="
                                            onBenchmarkingDataLoaded($event)
                                        "
                                    ></app-report-beachmarking-section>
                                </dsn-expand-collapse>
                            }
                            @if (preferenceService.viewPeformance) {
                                <dsn-expand-collapse
                                    id="SectionPerformance"
                                    [isExpanded]="
                                        sectionStates['SectionPerformance']
                                    "
                                    [customIcon]="
                                        'images/icons/performance-icon.svg'
                                    "
                                    [label]="'Performance'"
                                    [type]="'default'"
                                    [fontSize]="'large'"
                                >
                                    @if (!loading) {
                                        <app-report-performance
                                            [report]="report"
                                            [visualizations]="
                                                report.visualizations
                                            "
                                            [options]="report.options"
                                            [company]="company"
                                            [previewMode]="previewMode"
                                        ></app-report-performance>
                                    } @else {
                                        <div
                                            fxLayout="column"
                                            class="padding-12 gap-12"
                                        >
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="center center"
                                                class="gap-12"
                                            >
                                                <dsn-skeleton-loader
                                                    [type]="'circle'"
                                                    [width]="'80px'"
                                                    [height]="'80px'"
                                                ></dsn-skeleton-loader>
                                                <div
                                                    fxLayout="column"
                                                    class="gap-4"
                                                >
                                                    @for (
                                                        item of [1, 2, 3, 4];
                                                        track item
                                                    ) {
                                                        <dsn-skeleton-loader
                                                            [type]="'rectangle'"
                                                            [width]="'100px'"
                                                            [height]="'14px'"
                                                        ></dsn-skeleton-loader>
                                                    }
                                                </div>
                                            </div>
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'200px'"
                                                [height]="'20px'"
                                            ></dsn-skeleton-loader>
                                            <div fxLayout="row" class="gap-12">
                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'100px'"
                                                    [height]="'34px'"
                                                ></dsn-skeleton-loader>
                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'100px'"
                                                    [height]="'34px'"
                                                ></dsn-skeleton-loader>
                                            </div>
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'100%'"
                                                [height]="'38px'"
                                            ></dsn-skeleton-loader>
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'100%'"
                                                [height]="'38px'"
                                            ></dsn-skeleton-loader>
                                        </div>
                                    }
                                </dsn-expand-collapse>
                            }

                            <dsn-expand-collapse
                                id="SectionIndicators"
                                [isExpanded]="
                                    sectionStates['SectionIndicators']
                                "
                                [icon]="'fas fa-chart-line'"
                                [label]="'Indicadores'"
                                [type]="'transparent'"
                                [fontSize]="'large'"
                            >
                                <div fxLayout="column" class="gap-16">
                                    <app-table-balance
                                        [company]="company"
                                        [options]="report?.options"
                                        [loading]="loading"
                                    ></app-table-balance>
                                    @if (
                                        report?.visualizations?.visualzations
                                            ?.length
                                    ) {
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="start center"
                                            style="
                                                background-color: var(
                                                    --background-color-primary
                                                );
                                                top: 66px;
                                                z-index: 100;
                                                padding: var(--spacing-8) 0;
                                            "
                                            [style.position]="
                                                previewMode
                                                    ? 'inherit'
                                                    : 'sticky'
                                            "
                                        >
                                            @if (!previewMode) {
                                                <div fxLayout="column">
                                                    <ngx-popover
                                                        #popoverOrder
                                                        placement="bottom"
                                                    >
                                                        <dsn-button
                                                            iconLeft="fa-solid fa-exchange-alt fa-rotate-90"
                                                            iconRight="fas fa-caret-down"
                                                            [label]="
                                                                selectedOrder
                                                            "
                                                            type="tertiary"
                                                            prelabel="Ordenar por:"
                                                            [active]="true"
                                                            width="auto"
                                                            justify="start"
                                                            size="medium"
                                                        ></dsn-button>
                                                        <ng-template
                                                            ngx-popover-template
                                                        >
                                                            <div
                                                                class="dsn-popover size-medium"
                                                                fxLayout="column"
                                                                style="
                                                                    width: 263px;
                                                                    padding: 0;
                                                                "
                                                            >
                                                                <app-order-visualizations-options
                                                                    [options]="
                                                                        orderOptions
                                                                    "
                                                                    [value]="
                                                                        selectedOrder
                                                                    "
                                                                    (handleSelectOption)="
                                                                        onOrderChange(
                                                                            $event
                                                                        );
                                                                        popoverOrder.close()
                                                                    "
                                                                ></app-order-visualizations-options>
                                                            </div>
                                                        </ng-template>
                                                    </ngx-popover>
                                                </div>
                                            }

                                            <span fxFlex></span>
                                            @if (!previewMode) {
                                                <dsn-button
                                                    [label]="'Navegar'"
                                                    [type]="'tertiary'"
                                                    [iconLeft]="
                                                        'fa-solid fa-bars'
                                                    "
                                                    [size]="'medium'"
                                                    (click)="toggleDrawer()"
                                                ></dsn-button>
                                            }
                                        </div>
                                    }
                                    <div fxLayout="column" class="gap-16">
                                        @defer (when !loading) {
                                            @for (
                                                visualization of sortedVisualizations;
                                                track visualization.props._id
                                            ) {
                                                <div fxLayout="column">
                                                    <app-report-visualization
                                                        [loading]="loading"
                                                        [id]="
                                                            'visualization-' +
                                                            visualization.props
                                                                ._id
                                                        "
                                                        [visualization]="
                                                            visualization
                                                        "
                                                        [company]="company"
                                                        [report]="report"
                                                        class="report-visualization"
                                                        [previewMode]="
                                                            previewMode
                                                        "
                                                    ></app-report-visualization>
                                                </div>
                                            }
                                        } @placeholder {
                                            <div
                                                fxLayout="column"
                                                style="
                                                    gap: var(--spacing-8);
                                                    padding: var(--spacing-12);
                                                    border: var(
                                                            --border-width-1
                                                        )
                                                        solid
                                                        var(
                                                            --color-border-light
                                                        );
                                                    border-radius: var(
                                                        --border-radius-8
                                                    );
                                                "
                                            >
                                                <div fxLayout="row">
                                                    <dsn-skeleton-loader
                                                        [type]="'rectangle'"
                                                        [width]="'146px'"
                                                        [height]="'14px'"
                                                    ></dsn-skeleton-loader>
                                                    <span fxFlex></span>
                                                    <dsn-skeleton-loader
                                                        [type]="'rectangle'"
                                                        [width]="'126px'"
                                                        [height]="'14px'"
                                                    ></dsn-skeleton-loader>
                                                </div>

                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'126px'"
                                                    [height]="'12px'"
                                                    style="
                                                        margin-top: var(
                                                            --spacing-8
                                                        );
                                                    "
                                                ></dsn-skeleton-loader>

                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'106px'"
                                                    [height]="'28px'"
                                                ></dsn-skeleton-loader>

                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'36px'"
                                                    [height]="'12px'"
                                                ></dsn-skeleton-loader>
                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'100%'"
                                                    [height]="'400px'"
                                                    style="
                                                        margin-top: var(
                                                            --spacing-16
                                                        );
                                                    "
                                                ></dsn-skeleton-loader>
                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'100%'"
                                                    [height]="'40px'"
                                                    style="
                                                        margin-top: var(
                                                            --spacing-16
                                                        );
                                                    "
                                                ></dsn-skeleton-loader>
                                                <dsn-skeleton-loader
                                                    [type]="'rectangle'"
                                                    [width]="'100%'"
                                                    [height]="'40px'"
                                                    style="
                                                        margin-top: var(
                                                            --spacing-8
                                                        );
                                                    "
                                                ></dsn-skeleton-loader>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </dsn-expand-collapse>
                        </div>
                        @if (
                            !previewMode &&
                            contact?.props?._id !== "convidadoId"
                        ) {
                            <div fxLayout="column" fxLayoutAlign="start start">
                                <app-report-feedback
                                    [report]="report"
                                ></app-report-feedback>
                            </div>
                        }
                    </div>
                    @if (
                        !previewMode &&
                        contact?.props?._id !== "convidadoId" &&
                        chatNandaService.isOpen &&
                        preferenceService.viewIA &&
                        accountingPlanService.features["IAEmployee"]
                    ) {
                        @defer (when !loading) {
                            <div
                                [hidden]="!chatNandaService.isOpen"
                                fxLayout="column"
                                class="report-dashboard_desktop-component_section-nanda"
                                fxFlex="35"
                            >
                                <app-nanda-chat
                                    fxLayout="column"
                                    style="height: 100%"
                                    fxFlex
                                    [report]="report"
                                ></app-nanda-chat>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

@if (
    !previewMode &&
    contact?.props?._id !== "convidadoId" &&
    !loading &&
    preferenceService.viewIA &&
    accountingPlanService.features["IAEmployee"]
) {
    <app-nanda-icon (handleOpenChat)="onOpenChat()"></app-nanda-icon>
}
